import { Injectable } from '@angular/core';
import { CVApiService } from '../../../reusables/services/cv-api.service';
import { KpiData } from './kpi.model';

@Injectable({
    providedIn: 'root'
})
export class KpiService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    async LoadData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean) {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

            const queryString = `?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}&forGauge=false`;
            const url = `/api/v2/dashboards/modules/kpiData/${moduleKey}${queryString}`;

            const response = await this.cvApiService.get<KpiData>(url, moduleRenderURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    }

    async LoadDataForExport(moduleKey: string, format: string = 'excel', isCXOne: boolean = false) {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

            const queryString = `/export?format=${format}&forGauge=false&isCXOne=${isCXOne}`;
            const url = `/api/v2/dashboards/modules/kpiData/${moduleKey}${queryString}`;

            const response = await this.cvApiService.get<string>(url, moduleRenderURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (err) {
            console.error("Failed to get KPI export data");
            throw err;
        }
    }
}
